class EDCartRecommendations extends HTMLElement {
  connectedCallback() {
    this.load();
  }

  async load() {
    const cartProductIds = [...new Set(
      (this.dataset.cartProductIds || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean)
    )];

    if (!cartProductIds.length) return;

    const cartIds = new Set(cartProductIds);
    const chosen = [];
    const chosenIds = new Set();

    try {
      // First try true complementary recommendations for each basket product.
      await this.collectRecommendations(cartProductIds, 'complementary', cartIds, chosen, chosenIds);


      const products = chosen.slice(0, 2);
      if (!products.length) return;

      const grid = this.querySelector('[data-ed-rec-grid]');
      if (!grid) return;

      grid.innerHTML = products.map((product) => this.renderCard(product)).join('');
      this.hidden = false;
    } catch (_) {
      this.hidden = true;
    }
  }

  async collectRecommendations(sourceIds, intent, cartIds, chosen, chosenIds) {
    // Limit network work on very large baskets while still considering multiple product types.
    for (const sourceId of sourceIds.slice(0, 4)) {
      if (chosen.length >= 2) break;

      const products = await this.fetchRecommendations(sourceId, intent);

      for (const product of products) {
        const id = String(product.id);

        if (
          !product.available ||
          cartIds.has(id) ||
          chosenIds.has(id)
        ) {
          continue;
        }

        chosen.push(product);
        chosenIds.add(id);

        if (chosen.length >= 2) break;
      }
    }
  }

  async fetchRecommendations(productId, intent) {
    const root = window.Shopify?.routes?.root || '/';
    const url = root + 'recommendations/products.json?product_id=' +
      encodeURIComponent(productId) +
      '&limit=6&intent=' + encodeURIComponent(intent);

    const response = await fetch(url, {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });

    if (!response.ok) return [];

    const data = await response.json();
    return Array.isArray(data.products) ? data.products : [];
  }

  renderCard(product) {
    const image = product.featured_image || (product.images && product.images[0]) || '';
    const price = this.formatMoney(product.price);
    const title = this.escapeHtml(product.title || '');
    const href = product.url || ('/products/' + product.handle);
    const imageHtml = image
      ? '<img src="' + this.escapeAttribute(image) + '" alt="" loading="lazy" width="84" height="84">'
      : '';

    return '<a class="ed-cart-rec-card" href="' + this.escapeAttribute(href) + '">' +
      '<span class="ed-cart-rec-card__image">' + imageHtml + '</span>' +
      '<span class="ed-cart-rec-card__body">' +
        '<span class="ed-cart-rec-card__title">' + title + '</span>' +
        '<span class="ed-cart-rec-card__price">' + price + '</span>' +
      '</span>' +
    '</a>';
  }

  formatMoney(cents) {
    const value = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'GBP'
      }).format(value);
    } catch (_) {
      return '£' + value.toFixed(2);
    }
  }

  escapeHtml(value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  escapeAttribute(value) {
    return this.escapeHtml(value);
  }
}

if (!customElements.get('ed-cart-recommendations')) {
  customElements.define('ed-cart-recommendations', EDCartRecommendations);
}
